import { Autocomplete, Box, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import useColors from "../../../../../../api/hooks/useColors";
import AnchorPopper from "../../../../../../components/forms/AnchorPopper";
import {
  getTextFieldInputProps,
  StyledTextField,
  textFieldLabelProps,
} from "../../../../../../components/forms/styles/formFieldStyles";

const JiraLabels = ({ labelOptions }) => {
  const colors = useColors();
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext();

  const hasError = !!touched.labels && !!errors.labels;
  const errorMessage =
    hasError && typeof errors.labels === "string" ? errors.labels : "";

  const labelsLabel = useMemo(() => {
    const hasValue = values.labels?.length > 0;
    const labelText = hasValue ? "Labels" : "Select labels";

    return (
      <Box display="flex" alignItems="center" gap="4px">
        <Typography variant="caption">{labelText}</Typography>
      </Box>
    );
  }, [values.labels]);

  return (
    <>
      {labelOptions && (
        <Autocomplete
          options={labelOptions}
          value={values.labels}
          multiple
          freeSolo
          filterSelectedOptions
          onChange={(_, newValue) => setFieldValue("labels", newValue)}
          PopperComponent={AnchorPopper}
          renderOption={(props, option) => (
            <Box component="li" {...props}>
              <Typography variant="caption">{option}</Typography>
            </Box>
          )}
          renderInput={(params) => (
            <StyledTextField
              {...params}
              margin="dense"
              label={labelsLabel}
              fullWidth
              error={hasError}
              helperText={errorMessage}
              onBlur={handleBlur}
              InputProps={getTextFieldInputProps(params.InputProps)}
              InputLabelProps={textFieldLabelProps(params.InputLabelProps)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor:
                    colors.textfield_outlined_enabled_auto_generated_bg,
                },
              }}
            />
          )}
        />
      )}
    </>
  );
};
export default JiraLabels;
